import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteCarteiraCongelar } from '../cliente-carteira-congelar';
import { ClienteCarteiraCongelado } from '../cliente-carteira-congelado';

@Injectable({
    providedIn: 'root'
})
export class ClienteCarteiraCongelarHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clientecarteira/0/congelamento`;
    }

    /** Carrega os dados do congelamento de um cliente congelado */
    load(idCliente: number): Observable<ClienteCarteiraCongelado> {
        return this.customHttp.get<ClienteCarteiraCongelado>(`${this.pathApi}/${idCliente}`);
    }

    /** Realiza o congelamento do cliente informado */
    congelar(entityCongelamento: ClienteCarteiraCongelar): Observable<ClienteCarteiraCongelado> {
        return this.customHttp.put<ClienteCarteiraCongelado>(`${this.pathApi}/${entityCongelamento?.idCliente}`, entityCongelamento);
    }

    /** Realiza o descongelamento do cliente informado */
    descongelar(idCliente: number): Observable<ClienteCarteiraCongelado> {
        return this.customHttp.put<ClienteCarteiraCongelado>(`${this.pathApi}/${idCliente}/descongelar`, null);
    }
}
